'use client';

import React from 'react';
import type {
    DialogTriggerProps as AriaDialogTriggerProps,
    MenuTriggerProps as AriaMenuTriggerProps,
} from 'react-aria-components';
import { DialogTrigger as AriaDialogTrigger, MenuTrigger as AriaMenuTrigger } from 'react-aria-components';

const ROMA_POPOVER_DIALOG_TRIGGER_DISPLAY_NAME = 'RomaPopoverDialogTrigger';
const ROMA_POPOVER_MENU_TRIGGER_DISPLAY_NAME = 'RomaPopoverMenuTrigger';

export type DialogTriggerProps = AriaDialogTriggerProps;
export type MenuTriggerProps = AriaMenuTriggerProps;

/**
 * Use `DialogTrigger` for non-menu popovers such as detail panels, forms, and other anchored overlays
 * that should follow dialog semantics instead of menu semantics.
 */
export const DialogTrigger: React.FC<DialogTriggerProps> = ({ children, ...props }) => (
    <AriaDialogTrigger {...props}>{children}</AriaDialogTrigger>
);

DialogTrigger.displayName = ROMA_POPOVER_DIALOG_TRIGGER_DISPLAY_NAME;

/**
 * Use `MenuTrigger` for menu-style popovers such as command menus, context menus, and submenu overlays
 * that need menu keyboard semantics.
 */
export const MenuTrigger: React.FC<MenuTriggerProps> = ({ children, ...props }) => (
    <AriaMenuTrigger {...props}>{children}</AriaMenuTrigger>
);

MenuTrigger.displayName = ROMA_POPOVER_MENU_TRIGGER_DISPLAY_NAME;

export const PopoverTrigger = MenuTrigger;
export type PopoverTriggerProps = MenuTriggerProps;
